import { render, staticRenderFns } from "./AdyenBuyPremium.vue?vue&type=template&id=70301ce0&"
import script from "./AdyenBuyPremium.vue?vue&type=script&lang=js&"
export * from "./AdyenBuyPremium.vue?vue&type=script&lang=js&"
import style0 from "./AdyenBuyPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports